/* Hair Gummies PDP (sections/kc-*.liquid): gallery, purchase cards, rails,
   carousel dots, FAQ shortcuts, mobile sticky bar. The add-to-cart request
   itself is theme.js (form[data-atc-form]). */
(function () {
  'use strict';
  var fmt = (window.Nutritia && window.Nutritia.moneyFormat) || '${{amount}}';
  // Follows the shop's money format, so euros read "€28,76" like the Liquid prices.
  function money(c) {
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var a = (c / 100).toFixed(2);
      if (key === 'amount_no_decimals') return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return a.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (key === 'amount_no_decimals_with_comma_separator') return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (key === 'amount_with_apostrophe_separator') return a.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  /* Gallery */
  document.querySelectorAll('[data-kc-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-kc-slide]');
    var thumbs = g.querySelectorAll('[data-kc-thumb]');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: still});
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.dataset.kcThumb)); }); });
    g.querySelectorAll('[data-kc-step]').forEach(function (b) { b.addEventListener('click', function () { show(i + Number(b.dataset.kcStep)); }); });
    var x0 = null;
    var stage = g.querySelector('.kc-gallery__stage');
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, {passive: true});
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 8 && !e.target.closest('button')) openZoom();
      x0 = null;
    });

    /* Full-screen zoom: click (or tap) the big photo. Inside the viewer a
       click zooms 2.25x at the pointer and the mouse pans; on touch, double
       tap zooms and one finger pans. Arrows / swipe change photo, Esc or the
       backdrop closes. Built on <dialog>, so focus and Esc come for free. */
    var t = function (k, f) { return window.Nutritia && window.Nutritia.t ? window.Nutritia.t(k, f) : f; };
    var prevLabel = (g.querySelector('[data-kc-step="-1"]') || {}).ariaLabel || 'Previous image';
    var nextLabel = (g.querySelector('[data-kc-step="1"]') || {}).ariaLabel || 'Next image';
    var big = function (img) { return (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000'); };
    var dlg = null, zImg, zCount, zoomed = false;
    function setZoom(on, cx, cy) {
      zoomed = on;
      dlg.classList.toggle('is-zoomed', on);
      if (on && cx != null) pan(cx, cy);
      if (!on) zImg.style.transformOrigin = '';
    }
    function pan(cx, cy) {
      var r = zImg.getBoundingClientRect();
      var px = Math.max(0, Math.min(100, ((cx - r.left) / r.width) * 100));
      var py = Math.max(0, Math.min(100, ((cy - r.top) / r.height) * 100));
      zImg.style.transformOrigin = px + '% ' + py + '%';
    }
    function paint() {
      var img = slides[i];
      setZoom(false);
      zImg.src = big(img);
      zImg.alt = img.alt || '';
      if (zCount) zCount.textContent = (i + 1) + ' / ' + slides.length;
    }
    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'kc-zoom';
      dlg.setAttribute('aria-label', t('image_viewer', 'Product image viewer'));
      dlg.innerHTML =
        '<button type="button" class="kc-zoom__x" data-z="close" aria-label="' + t('close', 'Close') + '">&times;</button>' +
        '<div class="kc-zoom__stage"><img class="kc-zoom__img" alt="" draggable="false"></div>' +
        (slides.length > 1
          ? '<button type="button" class="kc-zoom__nav kc-zoom__nav--prev" data-z="-1" aria-label="' + prevLabel + '">&lsaquo;</button>' +
            '<button type="button" class="kc-zoom__nav kc-zoom__nav--next" data-z="1" aria-label="' + nextLabel + '">&rsaquo;</button>' +
            '<p class="kc-zoom__count" aria-live="polite"></p>'
          : '');
      document.body.appendChild(dlg);
      zImg = dlg.querySelector('.kc-zoom__img');
      zCount = dlg.querySelector('.kc-zoom__count');
      dlg.addEventListener('click', function (e) {
        var b = e.target.closest('[data-z]');
        if (b) {
          if (b.dataset.z === 'close') dlg.close();
          else { show(i + Number(b.dataset.z)); paint(); }
          return;
        }
        if (e.target === zImg) { if (!touchUsed) setZoom(!zoomed, e.clientX, e.clientY); return; }
        if (!zoomed) dlg.close();
      });
      dlg.addEventListener('mousemove', function (e) { if (zoomed) pan(e.clientX, e.clientY); });
      dlg.addEventListener('keydown', function (e) {
        if (slides.length > 1 && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { show(i + (e.key === 'ArrowRight' ? 1 : -1)); paint(); }
      });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('kc-zoom-open'); setZoom(false); });
      // Touch: double tap zooms, one finger pans while zoomed, swipe changes photo when not zoomed.
      var touchUsed = false, lastTap = 0, sx = null, sy = null;
      zImg.addEventListener('touchstart', function (e) {
        touchUsed = true;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        var now = Date.now();
        if (now - lastTap < 300) { setZoom(!zoomed, sx, sy); e.preventDefault(); lastTap = 0; } else lastTap = now;
      }, {passive: false});
      zImg.addEventListener('touchmove', function (e) {
        if (!zoomed || e.touches.length !== 1) return;
        e.preventDefault();
        pan(e.touches[0].clientX, e.touches[0].clientY);
      }, {passive: false});
      zImg.addEventListener('touchend', function (e) {
        if (zoomed || sx === null || slides.length < 2) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) { show(i + (dx < 0 ? 1 : -1)); paint(); }
        sx = null;
      });
    }
    function openZoom() {
      if (!slides.length) return;
      if (!dlg) build();
      if (dlg.open) return;
      paint();
      document.documentElement.classList.add('kc-zoom-open');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
    stage.classList.add('is-zoomable');
    var zBtn = document.createElement('button');
    zBtn.type = 'button';
    zBtn.className = 'kc-gallery__zoom';
    zBtn.setAttribute('aria-label', t('open_full', 'Open full-size image'));
    zBtn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.8-4.8M10.5 7.5v6M7.5 10.5h6"/></svg>';
    zBtn.addEventListener('click', openZoom);
    stage.appendChild(zBtn);
    stage.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      if (window.matchMedia('(hover: hover)').matches) openZoom();
    });
  });

  /* Purchase cards */
  document.querySelectorAll('[data-kc-buy]').forEach(function (box) {
    var form = box.querySelector('form[data-atc-form]');
    var qty = form.querySelector('[data-kc-qty]');
    var renew = box.querySelector('[data-kc-renew]');
    var modes = box.querySelectorAll('[data-kc-mode]');
    var cards = box.querySelectorAll('.kc-card');

    function mode() {
      var m = box.querySelector('[data-kc-mode]:checked');
      return m ? m.value : 'once';
    }
    // Limited-time offer: live until data-ends (unix seconds) on the offer box.
    var offerBox = box.querySelector('[data-kc-offer]');
    var ends = offerBox && offerBox.dataset.ends ? Number(offerBox.dataset.ends) * 1000 : 0;
    // Per-visitor countdown ("Countdown per visitor" setting): starts on the
    // first visit and is remembered in this browser. It never runs past the
    // offer's end date. When it ends, the offer really ends for this visitor.
    var windowMs = offerBox ? Number(offerBox.dataset.window || 0) * 3600000 : 0;
    if (windowMs) {
      var wKey = 'nutritia-offer-start-' + offerBox.dataset.windowKey;
      var start = 0;
      try { start = Number(localStorage.getItem(wKey)) || 0; if (!start) { start = Date.now(); localStorage.setItem(wKey, String(start)); } } catch (e) { start = Date.now(); }
      var personal = start + windowMs;
      ends = ends ? Math.min(ends, personal) : personal;
    }
    function offerOn() { return !ends || Date.now() < ends; }
    function showOffer(on) {
      document.querySelectorAll('[data-kc-offer-on]').forEach(function (el) { el.hidden = !on; });
      document.querySelectorAll('[data-kc-offer-off]').forEach(function (el) { el.hidden = on; });
      if (offerBox) offerBox.hidden = !on;
    }
    var clock = offerBox && offerBox.querySelector('[data-kc-clock]');
    var wasOn = offerOn();
    function tick() {
      var on = offerOn();
      // When the offer ends mid-visit, every quoted price (compare table,
      // popup) switches with the buy box, so the page never shows two prices.
      if (on !== wasOn) { wasOn = on; showOffer(on); sync(); fillTokens(); }
      if (!ends || !on) return;
      var left = Math.max(0, Math.floor((ends - Date.now()) / 1000));
      var parts = {d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60};
      // Text clocks: the offer line and the offer popup.
      var pad = function (x) { return String(x).padStart(2, '0'); };
      var text = parts.d ? parts.d + 'd ' + pad(parts.h) + 'h ' + pad(parts.m) + 'm ' + pad(parts.s) + 's'
        : (parts.h ? parts.h + 'h ' + pad(parts.m) + 'm ' : parts.m + 'm ') + pad(parts.s) + 's';
      document.querySelectorAll('[data-kc-clock-text]').forEach(function (el) { el.textContent = text; });
      if (!clock || clock.hasAttribute('data-kc-clock-text')) return;
      Object.keys(parts).forEach(function (k) {
        var el = clock.querySelector('[data-kc-t="' + k + '"]');
        if (el) el.textContent = String(parts[k]).padStart(2, '0');
      });
    }
    function sync() {
      var picked = box.querySelector('.kc-card:not([hidden]) input:checked');
      if (!picked) return;
      var offer = offerOn() && picked.dataset.offerTotal;
      // After the offer ends, a course with a fallback adds the 1-jar variant x jars.
      var useReg = !offer && picked.dataset.regVariant;
      qty.value = useReg ? picked.dataset.regQty : picked.value;
      var variant = useReg ? picked.dataset.regVariant : picked.dataset.variant;
      if (variant) form.querySelector('input[name="id"]').value = variant;
      var plan = form.querySelector('[name="selling_plan"]');
      if (picked.dataset.plan) {
        if (!plan) { plan = document.createElement('input'); plan.type = 'hidden'; plan.name = 'selling_plan'; form.appendChild(plan); }
        plan.value = picked.dataset.plan;
      } else if (plan) { plan.remove(); }
      var total = Number(offer ? picked.dataset.offerTotal : picked.dataset.total);
      var renewText = (offer ? picked.dataset.offerRenew : picked.dataset.renew) || '';
      document.querySelectorAll('[data-atc-price]').forEach(function (el) { el.textContent = money(total); });
      if (renew) { renew.textContent = renewText; renew.hidden = !renewText; }
      // Cashback line: % of what this option costs today (Shopify-style rounding to the cent).
      var cb = box.querySelector('[data-kc-cashback]');
      if (cb) {
        var amount = Math.round(total * Number(cb.dataset.kcCashback) / 100);
        cb.querySelector('span').textContent = (cb.dataset.kcCashbackText || 'Earn [amount] back in store credit').replace('[amount]', money(amount));
      }
      cons(picked);
    }

    // One-time drawbacks, recomputed for the chosen quantity.
    var consBox = box.querySelector('[data-kc-cons]');
    function cons(picked) {
      if (!consBox) return;
      var once = !picked.dataset.plan;
      consBox.hidden = !once;
      if (!once) return;
      var q = Number(picked.value);
      var total = Number(picked.dataset.total);
      var subUnit = Number(consBox.dataset.subUnit);
      var fee = Number(consBox.dataset.fee);
      var limit = Number(consBox.dataset.threshold);
      var line = function (k) { return consBox.querySelector('[data-kc-con="' + k + '"]'); };
      var gap = total - subUnit * q;
      line('price').hidden = !(subUnit && gap > 0);
      line('price').textContent = 'You pay ' + money(gap) + ' more than subscribers for the same ' + (q === 1 ? (box.dataset.unitWord || 'jar') : q + ' ' + (box.dataset.unitPlural || 'jars'));
      line('ship').hidden = !(fee && (!limit || total < limit));
      line('ship').textContent = window.Nutritia.t('ship_fee', '+ {fee} shipping. Subscriptions always ship free', {fee: money(fee)});
      line('reorder').textContent = window.Nutritia.t('reorder_days', 'You have to remember to reorder in {n} days, or your routine stops', {n: 30 * q});
    }
    if (consBox) consBox.querySelector('[data-kc-to-sub]').addEventListener('click', function () {
      var subMode = box.querySelector('[data-kc-mode][value="sub"]');
      if (subMode) { subMode.checked = true; applyMode(); subMode.closest('.kc-mode').scrollIntoView({behavior: still, block: 'nearest'}); }
    });

    // Quantity on the one-time card: full price per jar, no pack savings.
    box.querySelectorAll('[data-kc-qty-step]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var card = b.closest('.kc-card');
        var input = card.querySelector('input');
        var q = Math.min(12, Math.max(1, Number(input.value) + Number(b.dataset.kcQtyStep)));
        input.value = q;
        input.dataset.total = Number(input.dataset.unit) * q;
        input.checked = true;
        card.querySelector('[data-kc-qty-out]').textContent = q;
        card.querySelector('[data-kc-once-total]').textContent = money(Number(input.dataset.total));
        sync();
      });
    });
    function applyMode() {
      var m = mode();
      cards.forEach(function (c) { c.hidden = modes.length > 0 && c.dataset.kcGroup !== m; });
      var visible = box.querySelectorAll('.kc-card:not([hidden]) input');
      var checked = box.querySelector('.kc-card:not([hidden]) input:checked');
      if (!checked && visible.length) {
        // Opens on the card marked as the default (the badge card), else the first.
        var def = box.querySelector('.kc-card:not([hidden])[data-kc-default] input');
        var pick = def || visible[0];
        pick.checked = true;
      }
      sync();
    }
    modes.forEach(function (m) { m.addEventListener('change', function () { applyMode(); }); });
    cards.forEach(function (c) { c.querySelector('input').addEventListener('change', sync); });
    showOffer(wasOn);
    applyMode();
    tick();
    if (ends) setInterval(tick, 1000);
    // The offer popup never opens once the offer has ended.
    if (!wasOn) document.querySelectorAll('.nsu--offer').forEach(function (el) { el.remove(); });

    // Prices quoted elsewhere on the page ([data-kc-tok="first_per"
    // data-kc-pack="2"]) are read from the cards, so they always match.
    // Runs on load and again when the offer ends (see tick).
    function fillTokens() {
    document.querySelectorAll('[data-kc-tok]').forEach(function (el) {
      var input = box.querySelector('.kc-card[data-kc-pack="' + el.dataset.kcPack + '"] input') ||
        (el.dataset.kcPack === '0' ? box.querySelector('.kc-card--once input') : null);
      if (!input) return;
      var map = {total: 'total', per: 'per', pct: 'pct', save: 'save', first: 'offerTotal', first_per: 'firstPer', first_pct: 'firstPct', first_save: 'firstSave'};
      var tok = el.dataset.kcTok;
      // After the offer ends, first-order tokens show the regular price.
      if (!offerOn() || !input.dataset.offerTotal) tok = tok === 'first' ? 'total' : tok.replace(/^first_/, '');
      var val = input.dataset[map[tok]];
      if (el.dataset.kcPack === '0' && tok === 'per') val = input.dataset.unit;
      if (val === undefined) return;
      el.textContent = /pct/.test(tok) ? val + '%' : money(Number(val));
    });
    }
    fillTokens();

    // Anything with data-kc-pick="n" (offer box, "lock in your savings"
    // buttons) selects that subscription course and brings the buy box in.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-kc-pick]');
      if (!trigger) return;
      var card = box.querySelector('.kc-card[data-kc-pack="' + trigger.dataset.kcPick + '"] input');
      var subMode = box.querySelector('[data-kc-mode][value="sub"]');
      if (!card) return;
      e.preventDefault();
      if (subMode) { subMode.checked = true; }
      cards.forEach(function (c) { c.hidden = modes.length > 0 && c.dataset.kcGroup !== 'sub'; });
      card.checked = true;
      sync();
      if (!box.contains(trigger)) box.querySelector('.kc-cards').scrollIntoView({behavior: still, block: 'center'});
    });
  });

  /* Horizontal rails with arrow buttons */
  document.querySelectorAll('[data-kc-rail]').forEach(function (b) {
    b.addEventListener('click', function () {
      var track = b.closest('.kc-rail').querySelector('[data-kc-rail-track]');
      track.scrollBy({left: Number(b.dataset.kcRail) * track.clientWidth * 0.9, behavior: still});
    });
  });

  /* Carousel dots */
  document.querySelectorAll('[data-kc-carousel]').forEach(function (track) {
    var dots = track.parentNode.querySelector('[data-kc-dots]');
    if (!dots) return;
    function build() {
      var pages = Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
      dots.innerHTML = '';
      if (pages < 2) return;
      for (var p = 0; p < pages; p++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', window.Nutritia.t('page_n', 'Page {n}', {n: p + 1}));
        d.addEventListener('click', (function (n) { return function () { track.scrollTo({left: n * track.clientWidth, behavior: still}); }; })(p));
        dots.appendChild(d);
      }
      mark();
    }
    function mark() {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      dots.querySelectorAll('button').forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, {passive: true});
    window.addEventListener('resize', build);
    build();
  });

  /* Question chips open the matching FAQ answer */
  document.querySelectorAll('[data-kc-faq]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      var want = chip.dataset.kcFaq.trim().toLowerCase();
      var hit = null;
      document.querySelectorAll('#product-faq details').forEach(function (d) {
        if (d.querySelector('summary').textContent.trim().toLowerCase() === want) hit = d;
      });
      if (!hit) return;
      e.preventDefault();
      hit.open = true;
      hit.scrollIntoView({behavior: still, block: 'center'});
    });
  });

  /* Add-to-cart errors: Shopify answers "is already sold out" when the buyer's
     country is not in one of the store's markets. Everything on this page is
     rendered only when available, so say what actually happened. */
  var countryMsg = window.Nutritia.t('country_msg', 'Sorry, we can\u2019t ship this to your country yet.');
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      m.addedNodes.forEach(function (n) { fix(n.nodeType === 1 ? n : n.parentNode); });
      if (m.type === 'characterData' || m.type === 'childList') fix(m.target.nodeType === 1 ? m.target : m.target.parentNode);
    });
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
  function fix(el) {
    if (!el || !el.closest || !el.closest('.kc')) return;
    var err = el.matches('[data-atc-error]') ? el : el.closest('[data-atc-error]');
    if (err && /already sold out/i.test(err.textContent) && err.textContent !== countryMsg) err.textContent = countryMsg;
  }

  /* Mobile sticky bar: shown once the main button scrolls away */
  var sticky = document.querySelector('[data-kc-sticky]');
  var main = document.querySelector('.kc-form .kc-atc');
  if (sticky && main && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }).observe(main);
  }
})();
